import React from "react";
import { Table } from "antd";

const { Column } = Table;

export const AssetListListingComponent = ({
  listings = {},
  asset_listing_id,
}) => {
  const _listings = [];
  for (const i in listings) {
    let listingObj = { key: i, value: listings[i] };
    _listings.push(listingObj);
  }

  return (
    <div style={{ padding: "2%" }}>
      <Table
        width="80%"
        dataSource={_listings}
        size="small"
        pagination={false}
        bordered={true}
      >
        <Column name="key" dataIndex="key" title="Key" />
        <Column name="value" dataIndex="value" title="Value" />
      </Table>
    </div>
  );
};
